export default __webpack_public_path__ + "static/media/Turtlr-gameplay-screenshot-350px-233px.1cee0a82.jpg";